import Vue from "vue";
import LiquorTree from "liquor-tree";

// global registration
Vue.use(LiquorTree);
